// extracted by mini-css-extract-plugin
module.exports = {"root":"PageLayout_root__1GLuA","title":"PageLayout_title__2znon","actions":"PageLayout_actions__3ZdSe","content":"PageLayout_content__4glX4"};